import React, { useState, useEffect } from "react";
import "./ProgressBar.css";

interface ProgressBarProps {
  progress: number; // Progress in percentage
  // chunksCompleted: number ;
  // Number of completed chunks
}
const ProgressBar = ({ progress }: ProgressBarProps) => {
  const [currentProgress, setCurrentProgress] = useState(0);
  console.warn(currentProgress);
  useEffect(() => {
    // Update the progress bar only if the progress is between 0 and 100
    if (progress >= 0 && progress < 101) {
      setCurrentProgress(progress);
    }
  }, [progress]);

  return (
    <div >
      

      <div className="loader">
        <div
          className="loader-fill"
          style={{ width: `${currentProgress}%` }}></div>
      </div>
    </div>
  );
};

export default ProgressBar;
